"use client";
import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import AboutHeroSection from "@/components/AboutHeroSection";
import Image from "next/image";
import uiUx from "../../public/assets/images/services/uiux-design/ui-ux-design.png";
import {
  uiuxServices,
  uiuxTechnologies,
  uiuxTimeLine,
} from "../../utils/libs/utils";
const ServiceBox = ({ title, description, points }) => (
  <div className="service-inner-box w-100 ">
    <h3>{title}</h3>
    <p>{description}</p>
    <ul>
      {points.map((point, index) => (
        <li key={index}>{point}</li>
      ))}
    </ul>
  </div>
);

const UiUx = () => {
  useEffect(() => {
    const reveal = () => {
      document.querySelectorAll(".reveal").forEach((el) => {
        const windowHeight = window.innerHeight;
        const elementTop = el.getBoundingClientRect().top;
        const elementVisible = 10;

        if (
          elementTop < windowHeight - elementVisible &&
          !el.classList.contains("active")
        ) {
          el.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", reveal);
    reveal(); // run on load

    return () => window.removeEventListener("scroll", reveal);
  }, []);

  return (
    <div>
      <AboutHeroSection
        pillText="~ Our Tech Stack ~"
        title="UI/UX Design Development Services with"
        highlight="Neoverce"
        description="At Neoverce, we offer innovative and user-centered UI/UX design services that ensure your digital products provide a seamless and engaging experience. Our UI/UX designers combine cutting-edge design principles with advanced technology to create intuitive and visually compelling interfaces that align with your brand vision."
        imageAlt="UI/UX Design Development Services"
        image={uiUx}
      />
      <div className="py-5">
        <Container>
          <Row className="justify-content-center gy-4">
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Create Stunning UI with Our{" "}
                <span>Professional UI/UX Design Services</span>
              </h3>
              <p className="reveal fade-bottom">
                We take your complex ideas, toss them into the creative blender,
                and serve up simple, seamless, and totally addictive solutions
                that keep users hooked across all platforms. Our team of
                creative minds and out-of-the-box thinkers brings innovative
                ideas to the table, ensuring every design is not only functional
                but also visually stunning.
              </p>
            </Col>

            {uiuxServices.map((service, idx) => (
              <Col
                md={6}
                sm={12}
                key={idx}
                className="d-flex reveal fade-bottom"
              >
                <ServiceBox {...service} />
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <div className="service-section-bg my-5">
        <Container>
          <Row className="gy-4 justify-content-center">
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Advanced UI/UX Design Tools{" "}
                <span>for Best User Experience</span>
              </h3>
              <p className="reveal fade-bottom">
                At Neoverce,we use cutting-edge UI/UX design tools to create
                solutions tailored to your business needs. Our team combines
                creativity with functionality, using advanced tools to design
                intuitive and engaging user experiences across all platforms.
                Here's a look at the UI/UX design tools and technologies we
                leverage.
              </p>
            </Col>

            {uiuxTechnologies.map((tech, index) => (
              <Col
                key={index}
                lg={2}
                md={3}
                sm={4}
                xs={6}
                className="reveal fade-bottom d-flex"
              >
                <div className="tech-image-box text-center">
                  <Image
                    height={100}
                    width={100}
                    alt={tech.alt}
                    src={tech.src}
                    className="img-fluid"
                  />
                  <h3>{tech.name}</h3>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <div className="mt-5 py-5">
        <Container>
          <Row>
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Our Proven UI/UX <span>Design Development Process</span>
              </h3>
              <p className="reveal fade-bottom">
                Our design process is built to ensure that every project
                achieves excellence in both design and functionality. Our
                approach is iterative and includes collaboration, prototyping,
                and feedback at each stage to achieve the perfect result.
              </p>
            </Col>
          </Row>
          <div className="py-5">
            <Row className="timeline zipzap gx-0 position-relative">
              {uiuxTimeLine.map((step, i) => {
                const isFirst = i === 0;
                const isLast = i === uiuxTimeLine.length - 1;

                const timelineRowClass =
                  `timeline-row d-flex align-items-center pb-5 position-relative 
            ${isFirst ? "first-timeline" : ""} 
            ${isLast ? "last-timeline" : ""}`.trim();

                return (
                  <Col key={i} md={12} className={timelineRowClass}>
                    {i % 2 === 0 ? (
                      <>
                        <Col
                          md={6}
                          className="d-flex justify-content-center even-section align-items-center position-relative reveal fade-left d-none d-md-block"
                        >
                          <div className="timeline-icon-wrapper">
                            <span className="timeline-circle"></span>
                            <div className="timeline-line"></div>
                            <div className="timeline-icon">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="timeline-box text-box ms-md-5 reveal fade-right">
                            <div className="timeline-icon d-flex d-md-none w-fit-content mb-3 mt-0">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                          </div>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col md={6} className="text-md-end">
                          <div className="timeline-box text-box me-md-5 reveal fade-right">
                            <div className="timeline-icon d-flex d-md-none w-fit-content mb-3 mt-0">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                          </div>
                        </Col>
                        <Col
                          md={6}
                          className="d-flex justify-content-center align-items-center position-relative reveal fade-left d-none d-md-block"
                        >
                          <div className="timeline-icon-wrapper">
                            <span className="timeline-circle"></span>
                            <div className="timeline-line"></div>
                            <div className="timeline-icon">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                          </div>
                        </Col>
                      </>
                    )}
                  </Col>
                );
              })}
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default UiUx;
